import { combineReducers, createStore, ReducersMapObject, StoreEnhancer, Store } from "redux";
import { isDevEnv } from "@/lib/businessLogic";

declare global {
    interface Window {
        __REDUX_DEVTOOLS_EXTENSION__?: () => StoreEnhancer;
    }
}

export function createReduxStore(reducers: ReducersMapObject<unknown>): Store {
    const devtools = isDevEnv() && window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__();
    return devtools ? createStore(combineReducers(reducers), devtools) : createStore(combineReducers(reducers));
}
